import { el, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

import {
  applyTraits
} from '/programs/utilities/language.js';

import {
  isImageFile,
  isVideoFile,
  isDocumentFile
} from './utilities.js';

import FilePreview from './preview/index.js';

class FileInputRenderer {

  constructor(configuration) {

    this.formId = configuration.formId;
    this.page = configuration.page;

    this.file = null;

    this.filePreview = null;
    this.fileInput = null;
    this.buttonLabel = null;
    this.input = null;

    this.el = el('.form-editor-text-input-renderer', [
      this.renderInput()
    ]);

  }

  renderFileInput() {

    this.fileInput = el('input', {
      type: 'file',
      onchange: this.handleFileInputChange.bind(this),
      oninvalid: this.displayError.bind(this)
    });

    return this.fileInput;

  }

  renderInput() {

    this.buttonLabel = el('label.upload-button-label');
    this.filePreview = new FilePreview();
    this.errorLabel = el('label.error-message');

    this.input = el('.file-drop-zone-main', [
      this.filePreview,
      el('.drop-zone-content', [
        el('label.drop-zone-message-label', 'Drag your file here or upload via the button below'),
        el('p.file-size-information-label', 'Max file size: 5mb'),
        el('button.file-upload-button-link', {
          class: 'startup-themed-button',
          type: 'button',
          onclick: this.handleFileInputButtonClick.bind(this)
        }, [
          this.buttonLabel,
          this.renderFileInput()
        ]),
        this.errorLabel
      ])
    ]);

    return this.input;

  }

  handleFileInputButtonClick() {

    this.fileInput.click();

  }

  resetUploadButtonLabel() {

    this.updateButtonLabel();

  }

  async uploadFile(rawFile) {

    const apiInterface = await this.page.getDependency('api-interface');

    let response = null;

    if (isImageFile(rawFile) === true) {

      response = await apiInterface.forms.createFormImage(this.formId, rawFile);

    } else if (isVideoFile(rawFile) === true) {

      response = await apiInterface.forms.createFormVideo(this.formId, rawFile);

    } else if (isDocumentFile(rawFile) === true) {

      response = await apiInterface.forms.createFormDocument(this.formId, rawFile);

    }

    return new Promise((resolve, reject) => {

      response.on('progress', (event) => {
        this.buttonLabel.textContent = `Uploaded ${event.percent}%`;
      });

      response.on('error', reject);

      response.on('success', (files) => {
        this.file = files[0];
        resolve();
      });

    });

  }

  async handleFileInputChange(event) {

    const self = this;
    const rawFile = event.target.files[0];

    setAttr(this.fileInput, {
      disabled: true
    });

    this.buttonLabel.textContent = 'Uploading...';
    this.filePreview.setWorking();

    await this.uploadFile(rawFile);

    setAttr(this.fileInput, {
      disabled: false
    });

    this.clearError();
    this.buttonLabel.textContent = 'Uploaded';
    this.filePreview.setIdle();

    this.filePreview.displayFile(this.file);

    setTimeout(function sometimeLater() {
      self.resetUploadButtonLabel();
    }, 1000);

  }

  getValue() {

    return this.file;

  }

  resetFileInput() {

    this.fileInput.value = '';

  }

  clearError() {

    this.errorLabel.textContent = '';

  }

  reset() {

    this.file = null;
    this.clearError();

    this.filePreview.reset();
    this.resetFileInput();

  }

  isValid() {

    if (this.options.required === false) {
      return true;
    }

    return this.file !== null;

  }

  displayError() {

    this.errorLabel.textContent = 'Please select a file';

  }

  updateFileInput() {
    setAttr(this.fileInput, {
      required: this.options.required
    });
  }

  updateButtonLabel() {

    this.buttonLabel.textContent = this.options.buttonText;

  }

  update(options) {

    this.options = options;

    this.updateFileInput();
    this.updateButtonLabel();

  }

}

export default applyTraits(FileInputRenderer, []);